import PropTypes from 'prop-types';
export var scoringTierShape = PropTypes.shape({
  description: PropTypes.string.isRequired,
  percent: PropTypes.number.isRequired,
  count: PropTypes.number
});
export var scoringMethodShape = PropTypes.shape({
  algorithm: PropTypes.string.isRequired,
  algorithm_data: PropTypes.object,
  mastery_percent: PropTypes.number,
  points_possible: PropTypes.number,
  scoring_tiers: PropTypes.arrayOf(scoringTierShape)
});
export var outcomeShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  guid: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.string.isRequired,
  friendly_description: PropTypes.string,
  description: PropTypes.string,
  scoring_method: scoringMethodShape,
  group: PropTypes.bool,
  source_context_info: PropTypes.shape({
    name: PropTypes.string,
    context_type: PropTypes.string,
    uuid: PropTypes.string
  })
});
export var outcomeResultShape = PropTypes.shape({
  averageScore: PropTypes.number.isRequired,
  childArtifactCount: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  masteryCount: PropTypes.number.isRequired,
  outcomeId: PropTypes.string.isRequired,
  usesBank: PropTypes.bool
});
export var individualResultShape = PropTypes.shape({
  outcome: outcomeShape.isRequired,
  outcome_id: PropTypes.number.isRequired,
  outcome_rollup: PropTypes.shape({
    average_score: PropTypes.number.isRequired
  }).isRequired,
  percent_score: PropTypes.number.isRequired
});
export var outcomeCalculationMethodShape = PropTypes.shape({
  calculation_method: PropTypes.string.isRequired,
  calculation_int: PropTypes.number
});
export var outcomeProficiencyRatingShape = PropTypes.shape({
  color: PropTypes.string.isRequired,
  mastery: PropTypes.bool.isRequired,
  points: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired
});
export var outcomeProficiencyShape = PropTypes.shape({
  outcome_proficiency_ratings: PropTypes.arrayOf(outcomeProficiencyRatingShape).isRequired
});
export var contextShape = PropTypes.shape({
  outcome_calculation_method: outcomeCalculationMethodShape,
  outcome_proficiency: outcomeProficiencyShape
});
export var nMasteryDataShape = PropTypes.shape({
  n_mastery_count: PropTypes.number.isRequired
});
export var decayingAverageDataShape = PropTypes.shape({
  decaying_average_percent: PropTypes.number.isRequired
});
export var standardDecayingAverageDataShape = PropTypes.shape({
  standard_decaying_average_percent: PropTypes.number.isRequired
});
export var algorithmDataShape = PropTypes.oneOfType([nMasteryDataShape, decayingAverageDataShape, standardDecayingAverageDataShape]);
export var stylesShape = PropTypes.object;
export var selectedLaunchContextShape = PropTypes.shape({
  uuid: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});
export var launchContextsShape = PropTypes.arrayOf(selectedLaunchContextShape);